import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import actions from "./permission.actions";
import getters from "./permission.getters";
import mutations from "./permission.mutations";
import state from "./permission.state";
import PermissionState from "./permission.types";

const namespaced: boolean = true;

export const PermissionModule: Module<PermissionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};

export default PermissionModule;
